import { render, staticRenderFns } from "./CancelSubmitForm4.vue?vue&type=template&id=a8fee8f4&scoped=true"
import script from "./CancelSubmitForm4.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fee8f4",
  null
  
)

export default component.exports